import { useEffect, useRef, useState } from "react";
import AssetFleetProcessingMainContainer from "./AssetFleetProcessingMainContainer"
import { useSelector } from "react-redux";

const AssetFleetProcessingMainContainer_Container = () => {
    const wrapperRef = useRef<any>(null);
    const [selectedKey, setSelectedKey] = useState("fleet-processing");
    const [showFleetBreadcrumb, setShowFleetBreadcrumb] = useState(true);
    const [tabSwitchClicked, setTabSwitchClicked] = useState(false)
    const [tab, setTab] = useState('')
    const handleLinkClick = (item?: any) => {
      if (item) {
        if(item.props.itemKey === 'fleet-processing'){
          setSelectedKey(item.props.itemKey);
          setTab(item.props.itemKey)
          setShowFleetBreadcrumb(true)
          setTabSwitchClicked(false)
        } else {
          const fleetBreadCrumb = item.props.itemKey !== 'requisition'
          setTab(item.props.itemKey)
          setShowFleetBreadcrumb(fleetBreadCrumb)
          setTabSwitchClicked(true)
        }
      }
    };
    const activeNavigation = useSelector((state: any) => state.nav.nav)

    useEffect(() => {
        document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
    }, [activeNavigation]);
    return(
        <AssetFleetProcessingMainContainer 
        wrapperRef={wrapperRef} 
        selectedKey={selectedKey}
        setSelectedKey={setSelectedKey} 
        showFleetBreadcrumb={showFleetBreadcrumb} 
        handleLinkClick={handleLinkClick}
        tabSwitchClicked={tabSwitchClicked}
        setTabSwitchClicked={setTabSwitchClicked}
        setShowFleetBreadcrumb={setShowFleetBreadcrumb}
        tab={tab}
        />
    )
}

export default AssetFleetProcessingMainContainer_Container